import { render, staticRenderFns } from "./SemenCollectionTwo.vue?vue&type=template&id=520b6ce6&scoped=true&"
import script from "./SemenCollectionTwo.vue?vue&type=script&lang=js&"
export * from "./SemenCollectionTwo.vue?vue&type=script&lang=js&"
import style0 from "./SemenCollectionTwo.vue?vue&type=style&index=0&id=520b6ce6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520b6ce6",
  null
  
)

export default component.exports